"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const PopupPanel_vue_1 = require("./common/PopupPanel.vue");
const PreferencesManager_1 = require("../utils/PreferencesManager");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'KeyboardShortcuts',
    components: {
        PopupPanel: PopupPanel_vue_1.default,
    },
    computed: {
        preferences() {
            return PreferencesManager_1.getPreferences;
        },
    },
});
